import i18n from '@dms/i18n';

import {
  getTrimOrderability,
  getTrimOrderabilityDateLabel,
  getTrimOrderabilityLabel,
} from '../../utils/getTrimOrderability';
import type {OrderabilityChipProps} from './OrderabilityChip';

const translateWithDate = (key: string, options: {defaultValue: string; date: string}) => {
  const translation = i18n.t(key, options);
  return translation === key ? options.defaultValue.replace('{date}', options.date) : translation;
};

export function getTrimOrderabilityText(
  trim: OrderabilityChipProps['trim'],
  today: Date,
  formatDate: (date: Date) => string
) {
  const result = getTrimOrderability(trim, today);
  if (!result.date) {
    return getTrimOrderabilityLabel(result, (key, defaultValue) => i18n.t(key, {defaultValue}));
  }
  return getTrimOrderabilityDateLabel(result, formatDate(result.date), translateWithDate);
}
